module.exports = __webpack_public_path__ + "static/media/NightLightCheck.44210a0a.logo";